import { useState } from "react";
import { X, Truck } from "lucide-react";

export default function AnnouncementBar() {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return (
    <div data-testid="announcement-bar" className="bg-[#0055FF] text-white text-xs relative">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-2 flex items-center justify-center gap-2 font-mono uppercase tracking-widest">
        <Truck className="w-3.5 h-3.5" />
        <span>Nationwide Shipping Available — Need Help Confirming Fitment? Contact Our Team.</span>
      </div>
      <button
        data-testid="announcement-close"
        aria-label="Dismiss announcement"
        onClick={() => setVisible(false)}
        className="absolute right-3 top-1/2 -translate-y-1/2 opacity-80 hover:opacity-100"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
